export interface NotificationState {
  complianceNotificationStatus: ComplianceNotificationTypes;
  topPriorityComplianceNotification: AvailableComplianceNotifications | null;
  trainingNotificationStatus: TrainingNotificationTypes;
  topPriorityTrainingNotification: AvailableTrainingNotifications | null;
}

export interface NotificationType<T> {
  name: T;
  active: boolean;
  priority: number;
}

export interface ComplianceNotificationTypes {
  expired: NotificationType<AvailableComplianceNotifications>;
  lapsed: NotificationType<AvailableComplianceNotifications>;
  dueToExpire: NotificationType<AvailableComplianceNotifications>;
}

export interface TrainingNotificationTypes {
  trainingCancelled: NotificationType<AvailableTrainingNotifications>;
}

export enum AvailableComplianceNotifications {
  expired = 'notification_expired',
  lapsed = 'notification_lapsed',
  dueToExpire = 'notification_due_to_expire',
}

export enum AvailableTrainingNotifications {
  trainingCancelled = 'notification_training_cancelled',
}
